<template>
  <section class="eiendoms-velger mb-size-40">
    <div v-if="eiendommerLoading">
      <ods-spinner />
      {{ $t('eiendomsvelger.eiendommer.loading') }}
    </div>
    <ods-status-message
      v-else-if="eiendommerError"
      tittel="Melding om advarsel"
      :melding="$t('eiendomsvelger.eiendommer.error')"
      meldingstype="warning"
    />
    <template v-else>
      <div
        v-if="
          eiendommer.length === 0 &&
          folkeregistrertAdresse &&
          folkeregistrertAdresse.postadresser &&
          folkeregistrertAdresse.postadresser.length > 0 &&
          folkeregistrertAdresse.postadresser[0]
        "
      >
        {{
          $t('eiendomsvelger.eiendommer.adresse.folkeregistrert', {
            adresse: getAddressAsString(folkeregistrertAdresse),
          })
        }}
      </div>
      <div v-else class="ods-padding-bottom-3">
        <div class="ods-select">
          <label
            class="ods-block ods-text--size-india ods-text--weight-medium ods-margin-top-0 ods-margin-bottom-5 ods-text--size-golf-breakpoint-medium"
            for="selectAddress"
          >
            {{ $t('eiendomsvelger.eiendommer.adresse.velg') }}
            <div class="ods-select__select">
              <select id="selectAddress" v-model="selectedAdresse">
                <option
                  v-if="
                    folkeregistrertAdresse &&
                    folkeregistrertAdresse.postadresser &&
                    folkeregistrertAdresse.postadresser.length > 0 &&
                    folkeregistrertAdresse.postadresser[0]
                  "
                  selected
                  value="bolig"
                >
                  {{
                    $t('eiendomsvelger.eiendommer.adresse.folkeregistrert', {
                      adresse: getAddressAsString(folkeregistrertAdresse),
                    })
                  }}
                </option>
                <option v-for="(eiendom, index) in eiendommerFiltrert" :key="index" :value="index">
                  {{ getAddressAsString(eiendom) }}
                </option>
              </select>
            </div>
          </label>
        </div>
      </div>
      <data-kilde-info :translation-path="'eiendomsvelger.dataKildeInfo.bostedsinfo'" />
      <data-kilde-info :translation-path="'eiendomsvelger.dataKildeInfo.eiendomsinfo'" />
    </template>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DataKildeInfo from '@/components/DataKildeInfo.vue';
import OdsSpinner from '@/global-components/OdsSpinner.vue';
import OdsStatusMessage from '../global-components/OdsStatusMessage.vue';

export default {
  name: 'EiendomsVelger',

  components: {
    DataKildeInfo,
    OdsSpinner,
    OdsStatusMessage,
  },

  props: {
    valgtAdresse: {
      type: [String, Number],
      required: true,
    },
    eiendommerFiltrert: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    selectedAdresse: undefined,
  }),

  computed: {
    ...mapState('representasjoner', ['currentRepresentation']),
    ...mapState('eiendommer', ['eiendommer', 'eiendommerLoading', 'eiendommerError', 'folkeregistrertAdresse']),
  },

  watch: {
    selectedAdresse(value) {
      this.emitSelectedAddress(value);
      this.$emit('oppdatert-valgt-adresse', value);
    },

    valgtAdresse: {
      immediate: true,
      handler() {
        this.selectedAdresse = this.valgtAdresse;
      },
    },
  },

  methods: {
    ...mapActions(['addGlobalMessage']),

    getAddressAsString(eiendom) {
      if (eiendom.postadresser && eiendom.postadresser.length > 0) {
        const postadresse = eiendom.postadresser[0];
        return `${postadresse.vegadresse.gate} ${postadresse.vegadresse.husnr}
                    ${postadresse.vegadresse.bokstav ? postadresse.vegadresse.bokstav : ''}`;
      }
      return `${eiendom.matrikkeladresse.gardsnr}/${eiendom.matrikkeladresse.bruksnr}${
        eiendom.matrikkeladresse.seksjonsnr ? `/${eiendom.matrikkeladresse.seksjonsnr}` : ''
      }`;
    },

    emitSelectedAddress(value) {
      if (
        (this.folkeregistrertAdresse && this.folkeregistrertAdresse.postadresser) ||
        (this.eiendommer && this.eiendommer[value] && this.eiendommer[value].postadresser)
      ) {
        if (
          value === 'bolig' &&
          this.folkeregistrertAdresse &&
          this.folkeregistrertAdresse.postadresser[0].vegadresse
        ) {
          this.$emit('selectedAddress', this.folkeregistrertAdresse);
        } else if (
          this.eiendommer &&
          this.eiendommer[value] &&
          this.eiendommer[value].postadresser &&
          this.eiendommer[value].postadresser.length > 0 &&
          this.eiendommer[value].postadresser[0].vegadresse
        ) {
          this.$emit('selectedAddress', this.eiendommer[value]);
        } else {
          this.addGlobalMessage({
            messageType: 'error',
            message: this.$t('eiendomsvelger.eiendommer.adresse.error'),
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
.ods-select {
  max-width: 480px;
}
</style>
